import Vue from 'vue';
import axios from 'axios';
import flatPickr from 'vue-flatpickr-component';
import Multiselect from 'vue-multiselect';

Vue.config.performance = true;

window.app = new Vue({
    el: '#multiCityApp',
    data: {
        flight: {
            toPorts: [],
            fromPortSelected: [],
            toPortSelected: [],
            flightDate: new Date()
        },
        fromPorts: [],
        toPortSelected: [],
        flightsData: [],
        adultQuantity: 1,
        childrenQuantity: 0,
        infantsQuantity: 0,
        errors: [],
        currentFlightsCount: 1,
        maxFlightsCount: 4,
        config: {
            disableMobile: true,
            wrap: true,
            minDate: "today",
            defaultDate: "today",
            dateFormat: "d/m/Y"
        }
    },
    mounted: function () {
        this.flightsData.push({
            toPorts: [],
            fromPortSelected: [],
            toPortSelected: [],
            flightDate: new Date()
        });
    },
    created() {
        this.fetchFromPorts();
    },
    computed: {
        showRemoveButton: function () {
            return this.currentFlightsCount > 1;
        }
    },
    methods: {
        fetchFromPorts() {
            axios.get("/api/getMultiSelectFromPorts")
                .then(response => {
                    this.fromPorts = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },

        fetchToPorts(event, index) {
            axios.get("/api/getMultiSelectToPorts/" + event.portId)
                .then(response => {
                    this.flightsData[index].toPorts = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },

        addNewFlight() {
            if (this.currentFlightsCount < this.maxFlightsCount) {
                this.currentFlightsCount++;
                this.flightsData.push({
                    toPorts: [],
                    fromPortSelected: [],
                    toPortSelected: [],
                    flightDate: new Date()
                });
            } else {
                alert("Maximum " + this.maxFlightsCount +" flights are allowed");
            }
        },

        deleteRow(index) {
            this.currentFlightsCount--;
            this.flightsData.splice(this.flightsData.indexOf(index), 1);
        },

        incrementAdultQuantity() {
            this.adultQuantity++;
        },
        decrementAdultQuantity() {
            if (this.adultQuantity === 0) {
                alert('Negative quantity not allowed');
            } else {
                this.adultQuantity--;
            }
        },
        incrementChildrenQuantity() {
            this.childrenQuantity++;
        },
        decrementChildrenQuantity() {
            if (this.childrenQuantity === 0) {
                alert('Negative quantity not allowed');
            } else {
                this.childrenQuantity--;
            }
        },
        incrementInfantsQuantity() {
            this.infantsQuantity++;
        },
        decrementInfantsQuantity() {
            if (this.infantsQuantity === 0) {
                alert('Negative quantity not allowed');
            } else {
                this.infantsQuantity--;
            }
        },
        checkForm: function (e) {
            this.errors = [];
            if (this.flightsData.length) {
                for (var i = 0; i < this.flightsData.length; i++) {
                    if (this.flightsData[i].fromPortSelected.length === 0) {
                        this.errors.push('Flight ' + (i + 1) + ' from port is required.');
                    }
                    if (this.flightsData[i].toPortSelected.length === 0) {
                        this.errors.push('Flight ' + (i + 1) + ' to port is required.');
                    }
                    if (this.flightsData[i].flightDate === "") {
                        this.errors.push('Flight ' + (i + 1) + ' flight date is required.');
                    }
                }
            }

            if (!this.errors.length) {
                return true;
            }
            e.preventDefault();
        }


    },
    components: {
        flatPickr,
        Multiselect
    }
});

